import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gift } from "lucide-react";
import { useI18n } from "../../i18n";
import { usePromotions } from "./hooks";
import { trackPromo } from "./promoTrack";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../../components/ui/dialog";

// Shown once per new personal offer per user (the server records the "popup" event)
export const OfferPopup = () => {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const promos = usePromotions();
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    const next = (promos.data || []).find((o) => o.personal && !o.seen && (o.items || []).length);
    if (next && !offer) {
      setOffer(next);
      trackPromo(next.id, "popup");
    }
  }, [promos.data, offer]);
  if (!offer) return null;
  const close = () => setOffer({ ...offer, closed: true });
  return (
    <Dialog open={!offer.closed} onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-sm" data-testid="offer-popup">
        <Gift className="h-10 w-10 text-brand-ink" />
        <DialogTitle className="text-xl text-navy">{t("x.offers.popupTitle")}</DialogTitle>
        <DialogDescription className="text-base text-ink">{offer[`title_${lang}`] || offer.title_el}</DialogDescription>
        <div className="mt-2 flex gap-2">
          <button type="button" onClick={close} className="h-11 flex-1 rounded-full bg-canvas text-sm font-semibold text-navy" data-testid="offer-popup-later">{t("x.offers.later")}</button>
          <button type="button" onClick={() => { close(); nav(`/app/offers#offer-${offer.id}`); }} className="h-11 flex-1 rounded-full bg-brand text-sm font-semibold text-navy" data-testid="offer-popup-see">{t("x.offers.see")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
